export default "__VITE_ASSET__G3xg5$_y__"